<template>
  <div
    v-if="visible"
    class="fixed inset-0 z-50 flex items-end sm:items-center justify-center px-4 pb-6 sm:pb-0"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pwa-enable-notifications-title"
  >
    <div class="absolute inset-0 bg-black bg-opacity-60" @click="close" />
    <div class="relative w-full max-w-sm bg-white rounded-lg shadow-xl p-5">
      <h3 id="pwa-enable-notifications-title" class="text-lg font-semibold text-gray-900">
        Enable notifications
      </h3>
      <p class="mt-3 text-sm text-gray-700">
        Get notified for new messages, meeting requests, confirmations, and a reminder 10 minutes before each meeting.
      </p>
      <button
        type="button"
        class="mt-5 w-full rounded-md bg-red-700 text-white text-sm font-semibold py-2 px-3 hover:bg-red-600 focus:outline-none"
        @click="enable"
      >
        Turn on notifications
      </button>
      <button
        type="button"
        class="mt-2 w-full rounded-md bg-white text-gray-700 text-sm font-medium py-2 px-3 hover:bg-gray-50 focus:outline-none"
        @click="close"
      >
        Not now
      </button>
    </div>
  </div>
</template>

<script>
import eventBus from "../utils/eventBus";
import { enablePushFromUserGesture } from "../utils/pushNotifications";

export default {
  name: "PwaEnableNotificationsModal",
  data() {
    return {
      visible: false,
    };
  },
  created() {
    eventBus.$on("pwa-ask-notifications", this.open);
  },
  beforeDestroy() {
    eventBus.$off("pwa-ask-notifications", this.open);
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    async enable() {
      await enablePushFromUserGesture();
      this.close();
    },
  },
};
</script>
